import { render, staticRenderFns } from "./RelatorioConsolidadoParcelas.vue?vue&type=template&id=32797b66"
import script from "./RelatorioConsolidadoParcelas.vue?vue&type=script&lang=js"
export * from "./RelatorioConsolidadoParcelas.vue?vue&type=script&lang=js"
import style0 from "./RelatorioConsolidadoParcelas.vue?vue&type=style&index=0&id=32797b66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports